<div class="custom-scrollbar-css">
  <h2 class="modal-title">

    Configuration d'alarme d'accident </h2>

      <div class="container-fluid mt-3">


        

          <mat-horizontal-stepper>
            <form class="mt-4" [formGroup]="registerForm2" (submit)="submitFormupdate()"> 
            <mat-step label="Info.générales " state="phone">
              <div>
                <div class="row">

                  <div class="col-6 col-md-12 w-100">
                  <h1 class="p-2 ">
                    <img  width="25px" height="25px" src="data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MTIgNTEyIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHdpZHRoPSI1MTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGc+PHBhdGggZD0ibTI1NiAzOTIuNSAyNi41MDIgNDUuMTI5LTI2LjUwMiA0NS4xMjFoLTIxMC44OGMtMjQuODggMC00NS4xMi0yMC4yNC00NS4xMi00NS4xMnMyMC4yNC00NS4xMyA0NS4xMi00NS4xM3oiIGZpbGw9IiMzYmE5ZmYiLz48cGF0aCBkPSJtNTEyIDQzNy42M2MwIDI0Ljg4LTIwLjI0IDQ1LjEyLTQ1LjEyIDQ1LjEyaC0yMTAuODh2LTkwLjI1aDIxMC44OGMyNC44OCAwIDQ1LjEyIDIwLjI1IDQ1LjEyIDQ1LjEzeiIgZmlsbD0iIzAwODFmZiIvPjxwYXRoIGQ9Im0yNTYgMjEwLjg4IDIzIDQ1LjEyLTIzIDQ1LjEyaC0yMTAuODhjLTI0Ljg4IDAtNDUuMTItMjAuMjQtNDUuMTItNDUuMTJzMjAuMjQtNDUuMTIgNDUuMTItNDUuMTJ6IiBmaWxsPSIjM2JhOWZmIi8+PHBhdGggZD0ibTUxMiAyNTZjMCAyNC44OC0yMC4yNCA0NS4xMi00NS4xMiA0NS4xMmgtMjEwLjg4di05MC4yNGgyMTAuODhjMjQuODggMCA0NS4xMiAyMC4yNCA0NS4xMiA0NS4xMnoiIGZpbGw9IiMwMDgxZmYiLz48cGF0aCBkPSJtMjU2IDI5LjI1IDIzIDQ1LjEyMS0yMyA0NS4xMjloLTIxMC44OGMtMjQuODggMC00NS4xMi0yMC4yNS00NS4xMi00NS4xM3MyMC4yNC00NS4xMiA0NS4xMi00NS4xMnoiIGZpbGw9IiMzYmE5ZmYiLz48cGF0aCBkPSJtNTEyIDc0LjM3YzAgMjQuODgtMjAuMjQgNDUuMTMtNDUuMTIgNDUuMTNoLTIxMC44OHYtOTAuMjVoMjEwLjg4YzI0Ljg4IDAgNDUuMTIgMjAuMjQgNDUuMTIgNDUuMTJ6IiBmaWxsPSIjMDA4MWZmIi8+PGNpcmNsZSBjeD0iMTQyLjM0NiIgY3k9IjI1NiIgZmlsbD0iI2ZmNWU5NCIgcj0iNzQuMzcxIi8+PGVsbGlwc2UgY3g9IjM2Mi43MSIgY3k9Ijc0LjM3MSIgZmlsbD0iI2ZmMzk4MCIgcng9Ijc0LjM3IiByeT0iNzQuMzciIHRyYW5zZm9ybT0ibWF0cml4KC43MDcgLS43MDcgLjcwNyAuNzA3IDUzLjY0NyAyNzguMjU4KSIvPjxwYXRoIGQ9Im0yNTYgMzYzLjI2IDE1IDczLjI4OS0xNSA3NS40NTFjLTQxLjAxIDAtNzQuMzctMzMuMzYtNzQuMzctNzQuMzdzMzMuMzYtNzQuMzcgNzQuMzctNzQuMzd6IiBmaWxsPSIjZmY1ZTk0Ii8+PHBhdGggZD0ibTMzMC4zNyA0MzcuNjNjMCA0MS4wMS0zMy4zNiA3NC4zNy03NC4zNyA3NC4zN3YtMTQ4Ljc0YzQxLjAxIDAgNzQuMzcgMzMuMzYgNzQuMzcgNzQuMzd6IiBmaWxsPSIjZmYzOTgwIi8+PC9nPjwvc3ZnPg==" />
                  Niveau</h1>
                  <div class="disabledInput">
                  <mat-form-field  appearance="fill"  class="example-full-width" class="w-100 mb-3">
                    <mat-label>Compagnie</mat-label>
                    <input matInput #input  value="{{name}}">
                  </mat-form-field>

                  </div>
                </div>
        
                  </div>
                 
           
              </div>
            </mat-step>
            
            <mat-step label="Notifications" state="notif">
              <div class="row">

                <div class="col-6 col-md-12 w-100">
                <h1 class="p-2 ">
                  <img width="25px" height="25px" src="data:image/svg+xml;base64,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" />
                  Notifications</h1>
      
                  <div class="row">
                    <div class="col-md-2">
                    </div>
  <div class="col-md-10">

  </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-10 w-100" >
                      <!--   <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 20px;">
                            <mat-label>Rechercher contact</mat-label>
                            <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field> -->



                        <form>
                          <mat-form-field appearance="fill"  style="width: 100%; margin-bottom: 20px;" (click)="hiddencontenu()">
                            <mat-label>Sélectionner un contact déjà existant </mat-label>
                            <!--(keyup)="applyFilterer($event)"-->
                            <input type="text" aria-label="Number"  matInput (keyup)="applyFilter1($event)" (click)="hiddencontenu2()"
                              [formControl]="myControl" [matAutocomplete]="auto" />
              
              
              
                            <button mat-button matSuffix mat-icon-button>
                              <mat-icon placement="bottom" ngbTooltip="Actualiser la liste des contacts" (click)="refrech()">refresh</mat-icon>
              
                            </button>
                            <button mat-button  matSuffix mat-icon-button (click)="hiddencontenu()">
                              <mat-icon placement="bottom" ngbTooltip="Lister les contacts">filter_list</mat-icon>
              
                            </button>
              
              
                            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                              
              
                              <table class="table-hover" mat-table [dataSource]="dataSourcet">
                                <!-- Position Column -->
                                <ng-container matColumnDef="position">
                                  <th mat-header-cell *matHeaderCellDef>Contact.</th>
                                  <td (click)="getContact_notif()" mat-cell *matCellDef="let elementt" [ngClass]="{
                                      highlight: selectedRowIndex2 == elementt.id
                                    }" (click)="getItemDetails2(elementt)">
                                    <strong> Name: {{ elementt.first_name }} </strong> <br />
                                    Id: {{ elementt.id }} <br />
              
                                    Email: {{ elementt.email }}
                                  </td>
                                </ng-container>
              
                                <tr class="d-none" mat-header-row *matHeaderRowDef="displayedColumnst"></tr>
                                <tr mat-row *matRowDef="let elementt; columns: displayedColumnst"></tr>
                              </table>
              
                              <mat-paginator #secondPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
              
                              <mat-option class="d-none"> </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </form>
    



                        </div>
                    <div class="col-md-2 w-100" style="text-align: center ;     padding-top: 4px;">
  <img data-toggle="collapse"  (click)="add_contact()" placement="bottom" ngbTooltip="Ajouter un nouveau contact" data-target="#collapseMalasngoding" aria-expanded="false"   aria-controls="collapseMalasngoding" width="40px" height="40px"
  src="https://img.icons8.com/pastel-glyph/64/4a90e2/business-contact.png"  />
                      <img  placement="bottom" ngbTooltip="Confirmer"  (click)="submitcontact()" *ngIf="new_contact == true && registerFormContact.valid" 
                      width="40px" height="40px" 
                      src="https://img.icons8.com/ios/64/4a90e2/ok--v1.png" />
                        
                    </div>
                    </div>
                    <div class="collapse" id="collapseMalasngoding">
                           <!--  <mat-radio-group aria-label="Select an option" >
                        <div class="row" style=" margin-bottom: 15px;">
                            <div class="col-md-3">
                            </div>
                            <div class="col-md-3">
                                <mat-radio-button  (click)="select_contact()" value="1">Sélectionner un contact existant
                                </mat-radio-button>
                        
                            </div>
                            <div class="col-md-3">
                                <mat-radio-button (click)="add_contact()" value="2">Créer un nouveau contact</mat-radio-button>
                        
                            </div>
                            <div class="col-md-3">
                            </div>
                        </div>
                        </mat-radio-group>
                    <div class="row">
                        <div class="col-md-4">
                    
                        </div>
                        <div class="col-md-4">
                            <mat-form-field *ngIf="new_contact == false" appearance="fill" style=" width: 100%; margin-bottom: 20px;">
                                <mat-label>Contacts</mat-label>
                                <mat-select [formControl]="contacts">
                                  <mat-option *ngFor="let contact of contactList" [value]="contact">{{contact.first_name}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            
                        </div>
                    </div> -->



                    <div class="row">
                      <div class="col-md-4">
                  
                      </div>
                      <div class="col-md-4">
    
    
    
    
                     <!--    <form>
                          <mat-form-field appearance="fill" (click)="hiddencontenu()">
                            <mat-label>Filtrer par contact</mat-label>
                            
                            <input type="text" aria-label="Number"  matInput (keyup)="applyFilter1($event)" (click)="hiddencontenu2()"
                              [formControl]="myControl" [matAutocomplete]="auto" />
              
              
              
                            <button mat-button matSuffix mat-icon-button>
                              <mat-icon matTooltip="Actualiser les données des véhicules " (click)="refrech()">refresh</mat-icon>
              
                            </button>
                            <button mat-button  matSuffix mat-icon-button (click)="hiddencontenu()">
                              <mat-icon matTooltip="Liste vehicule">filter_list</mat-icon>
              
                            </button>
              
              
                            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                              
              
                              <table class="table-hover" mat-table [dataSource]="dataSourcet">
                                
                                <ng-container matColumnDef="position">
                                  <th mat-header-cell *matHeaderCellDef>Contact.</th>
                                  <td (click)="getContact_notif()" mat-cell *matCellDef="let elementt" [ngClass]="{
                                      highlight: selectedRowIndex2 == elementt.id
                                    }" (click)="getItemDetails2(elementt)">
                                    <strong> Name: {{ elementt.first_name }} </strong> <br />
                                    Id: {{ elementt.id }} <br />
              
                                    Email: {{ elementt.email }}
                                  </td>
                                </ng-container>
              
                                <tr class="d-none" mat-header-row *matHeaderRowDef="displayedColumnst"></tr>
                                <tr mat-row *matRowDef="let elementt; columns: displayedColumnst"></tr>
                              </table>
              
                              <mat-paginator #secondPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
              
                              <mat-option class="d-none"> </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </form> -->
    
    
    
                          <mat-form-field *ngIf="new_contact == false" appearance="fill" style=" width: 100%; margin-bottom: 20px;">
                              <mat-label>Contacts</mat-label>
                              <mat-select [formControl]="contacts">
                                <mat-option *ngFor="let contact of contactList" [value]="contact">{{contact.first_name}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                      </div>
                      <div class="col-md-4">
                          
                      </div>
                  </div>

                    <form class="mt-4" [formGroup]="registerFormContact" (submit)="submitcontact()">
                    <div class="row" *ngIf="new_contact == true">
                        <div class="col-md-6" style=" margin-bottom: 20px;">
                            <mat-form-field class="example-full-width" appearance="fill" style="width: 100%;" >
                                <mat-label>Nom</mat-label>
                                <input matInput   formControlName="last_name" required [errorStateMatcher]="matcher">
                                  
                                 <mat-error *ngIf="registerFormContact.get('last_name').hasError('pattern')">Veuillez saisir
                                  une format valide !
                                </mat-error>
                                <mat-error *ngIf="registerFormContact.get('last_name').hasError('required')">
                                  Prénom est <strong>Obligatoire</strong>
                                </mat-error>
                              </mat-form-field>
                        </div>
                        <div class="col-md-6" style=" margin-bottom: 20px;">
                            <mat-form-field  class="example-full-width" appearance="fill" style="width: 100%;">
                                <mat-label>Prénom</mat-label>
                                <input matInput   formControlName="first_name"  required [errorStateMatcher]="matcher">
                                <mat-error *ngIf="registerFormContact.get('first_name').hasError('pattern')">Veuillez saisir
                                  une format valide !
                                </mat-error>
                                <mat-error *ngIf="registerFormContact.get('first_name').hasError('required')">
                                  Prénom est <strong>Obligatoire</strong>
                                </mat-error>
                              </mat-form-field>
                        </div>
                        
                    </div>
                    
                    <div class="row" *ngIf="new_contact == true">
                        <div class="col-md-6" style=" margin-bottom: 20px;">
                            <mat-form-field  class="example-full-width" appearance="fill" style="width: 100%;">
                                <mat-label>Courrier électronique</mat-label>
                                <input matInput  formControlName="email"   required [errorStateMatcher]="matcher">
                               
                            <mat-error *ngIf="registerFormContact.get('email').hasError('email')">Veuillez saisir une
                              format valide !
                            </mat-error>
                            <mat-error *ngIf="registerFormContact.get('email').hasError('required')">
                              Email est <strong>Obligatoire</strong>
                            </mat-error>
                              </mat-form-field>
                        </div>
                        <div class="col-md-6" style=" margin-bottom: 20px;">
                            <mat-form-field  class="example-full-width" appearance="fill" style="width: 100%;">
                                <mat-label>Numéro de téléphone</mat-label>
                                <input matInput  formControlName="gsm_number" >
                              </mat-form-field>
                        </div>
                        
                    </div>
                    
                  </form>
                    
                    </div>
                    
                    
                    
                    
                    
                    
                    <table mat-table [dataSource]="dataSourceC" class="mat-elevation-z8">
    
                      <!--- Note that these columns can be defined in any order.
                            The actual rendered columns are set as a property on the row definition" -->


                                        <!-- Checkbox Column -->
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef  >
                
            </th>

            <td (click)="selection.toggle(element)" mat-cell *matCellDef="let element">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null" [checked]="selection.isSelected(element)" [aria-label]="checkboxLabel(element)">
                </mat-checkbox>
            </td>
        </ng-container>
                    
                    
                      <!-- ID Column -->
                      <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef> ID. </th>
                        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                      </ng-container>
                    
                      <!-- Prénom Column -->
                      <ng-container matColumnDef="first_name">
                        <th mat-header-cell *matHeaderCellDef> Prénom </th>
                        <td mat-cell *matCellDef="let element"> {{element.first_name}} </td>
                      </ng-container>
                    
                      <!-- Nom Column -->
                      <ng-container matColumnDef="last_name">
                        <th mat-header-cell *matHeaderCellDef> Nom </th>
                        <td mat-cell *matCellDef="let element"> {{element.last_name}} </td>
                      </ng-container>
                    
                      <!-- email Column -->
                      <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef> email </th>
                        <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                      </ng-container>
    
                       <!-- delete Column -->
                       <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef> Actions </th>
                        <td mat-cell *matCellDef="let element ; let i= index" style="justify-content: end;">
                          <img (click)="Delete_contact(i)" placement="left" ngbTooltip="Supprimer contact" width="35px"
                            height="35px"
                            src="https://img.icons8.com/ios/50/4a90e2/delete-sign.png"/>
    
                        </td>
                      </ng-container>
                    
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>
                    </table>
                    </div>
                  </div>
      
                </div>
      
      
                </div>
            </mat-step>
          
            <!-- Icon overrides. -->
            <ng-template matStepperIcon="phone">
              <mat-icon>notifications</mat-icon>
            </ng-template>
            <ng-template matStepperIcon="chat">
              <mat-icon>schedule</mat-icon>
            </ng-template>
            <ng-template matStepperIcon="notif">
              <mat-icon>notifications_active</mat-icon>
            </ng-template>
            </form>
          </mat-horizontal-stepper>
          





     
        </div>
        </div>
        <div class=" justify-content-center d-flex mt-1 mb-3">
          <a [ngClass]="{colorIconActive : registerForm2.valid    ,colorIconInactive : !registerForm2.valid   }" class="btn text-uppercase mr-2" type="submit" (click)="submitFormupdate()" >enregristrer</a>
  
                <a class="btn text-uppercase" type="submit" aria-pressed="true" (click)="onNoClick()">Annuler</a>
      </div>


      